import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { whatsappAPI } from './api';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const WHATSAPP_NUMBER = "918828509080";

export const getWhatsAppLink = (message = "Hi DrPortals, I'd like help finding a verified dermatologist and booking a consultation.") => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

// Track WhatsApp clicks
export const trackWhatsAppClick = async (sourcePage, doctorId = null, doctorName = null, message = null) => {
  try {
    await whatsappAPI.track({
      source_page: sourcePage,
      doctor_id: doctorId,
      doctor_name: doctorName,
      message: message
    });
  } catch (error) {
    console.error('Failed to track WhatsApp click:', error);
  }
};

export const getCategoryColor = (category) => {
  const colors = {
    Skin: { bg: 'bg-amber-50', text: 'text-amber-900', accent: '#fef3c7' },
    Hair: { bg: 'bg-gray-800', text: 'text-white', accent: '#1f2937' },
    Weight: { bg: 'bg-emerald-50', text: 'text-emerald-900', accent: '#d1fae5' },
    Aesthetic: { bg: 'bg-purple-50', text: 'text-purple-900', accent: '#f5d0fe' },
  };
  return colors[category] || { bg: 'bg-gray-50', text: 'text-gray-900', accent: '#f3f4f6' };
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};
